import { render } from "./PanelSuggestions.vue?vue&type=template&id=2e5a7116"
import script from "./PanelSuggestions.vue?vue&type=script&lang=js"
export * from "./PanelSuggestions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__